import { ApiAuthUser } from "@incendium/api";
import { listProjectUsers } from "features/users/services/userService";
import { useProjectSharedState } from "Hooks/useSharedState";

export const useProjectUsers = () => {
  const fetchUsers = async (selectedProject) => {
    if (!selectedProject) {
      return [];
    }
    const res = await listProjectUsers(selectedProject.id);
    return res || [];
  };
  const { state, setState, refetch, loading } = useProjectSharedState<
    ApiAuthUser[]
  >("projectUsers", [], fetchUsers);

  return {
    users: state,
    loading,
    setUsers: setState,
    refetchUsers: refetch,
  };
};
